import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=640969d2&scoped=true"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"
import style0 from "./RatingStars.vue?vue&type=style&index=0&id=640969d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640969d2",
  null
  
)

export default component.exports